import { render, staticRenderFns } from "./UploadYoutube.vue?vue&type=template&id=709d0138&scoped=true"
import script from "./UploadYoutube.vue?vue&type=script&lang=js"
export * from "./UploadYoutube.vue?vue&type=script&lang=js"
import style0 from "./UploadYoutube.vue?vue&type=style&index=0&id=709d0138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709d0138",
  null
  
)

export default component.exports